<template>
  <div>
    <img src="@/assets/image/home/navBar.png" width="200px" height="40px" >
        <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical-demo nav"
            background-color="#fff"
            text-color="#007fff"
            router
            active-text-color="#234C9C"
            @open="handleOpen"
            @close="handleClose">
          <el-menu-item index="/admin/unit"  style="width: 100%">
            <i class="el-icon-menu"></i>
            <span slot="title">成员单位</span>
          </el-menu-item>
          <el-menu-item index="/admin/leader"  style="width: 100%">
            <i class="el-icon-s-custom"></i>
            <span slot="title">公司领导</span>
          </el-menu-item>
          <el-menu-item index="/admin/article"  style="width: 100%">
            <i class="el-icon-s-management"></i>
            <span slot="title">文章管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/honor"  style="width: 100%">
            <i class="el-icon-s-management"></i>
            <span slot="title">荣誉墙管理</span>
          </el-menu-item>
<!--          <el-menu-item index="/admin/unit" style="width: 100%;border-bottom: #7777ea solid 1px" class="menu-item">-->
<!--            <div  style="width: 200px;text-align: center">成员单位</div>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="/admin/leader" style="width: 100%;border-bottom: #7777ea solid 1px" class="menu-item">-->
<!--            <div  style="width: 200px;text-align: center">公司领导</div>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="/admin/article" style="width: 100%;border-bottom: #7777ea solid 1px" class="menu-item">-->
<!--            <div   style="width: 200px;text-align: center">文章管理</div>-->
<!--          </el-menu-item>-->
        </el-menu>
  </div>
</template>

<script>
export default {
  name: "adminNavBar",
  data (){
    return {
      activeIndex:''
    }
  },
  methods :{
    handleOpen(){

    },
    handleClose(){

    }
  }
}
</script>

<style >
.nav{
  width: 200px;
  height: 95vh;
}
.menu-item.is-active{
background-color: #007fff !important;
}
.el-menu-item:hover{
  /*background-color: white !important;*/
}
</style>
